<template>
  <div>
    <PreLoader v-if="isLoading" />

    <CustomBottomSheet
      refName="UserFamilyUpdate"
      size="xl"
      :headerText="$t('UserFamilies.edit')"
      :headerIcon="userFamily.icon"
      :clickToClose="false"
      :swipeAble="false"
    >
      <UserFamilyForm
        v-if="!isLoading"
        id="update"
        :userTypeToken="userFamily.userTypeToken"
        :userFamily="userFamily"
        v-on:submitForm="updateUserFamily()"
        :deleteFileStatus="true"
        v-on:deleteFile="deleteFile()"
        bottomSheetName="UserFamilyUpdate"
        :submitName="$t('edit')"
      />
    </CustomBottomSheet>
  </div>
</template>

<script>
import PreLoader from "./../../../../components/general/PreLoader.vue";
import CustomBottomSheet from "./../../../../components/general/CustomBottomSheet.vue";
import UserFamilyForm from "./UserFamilyForm.vue";
import { STATUS } from "./../../../../utils/constants";
import { objectToFormData } from "./../../../../utils/functions";
import UserDelete from "./../../../../models/users/UserDelete";
import apiUserFamily from "./../../../../api/usersPersonalData/userFamilies";
import generalMixin from "./../../../../utils/generalMixin";

export default {
  mixins: [generalMixin],
  components: {
    PreLoader,
    CustomBottomSheet,
    UserFamilyForm,
  },
  props: ["userFamily"],
  data() {
    return {
      model: new UserDelete(),
    };
  },
  methods: {
    async updateUserFamily() {
      this.isLoading = true;
      let formData = objectToFormData(this.userFamily);
      try {
        const response = await apiUserFamily.update(formData);
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.closeBottomSheet("UserFamilyUpdate");
          this.$emit("refresh");
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.showMsg(response.data.msg);
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async deleteFile() {
      this.isLoading = true;
      try {
        this.model.fillData({
          token: this.userFamily.userFamilyToken,
          userTypeToken: this.userFamily.userTypeToken,
        });
        let formData = objectToFormData(this.model);
        const response = await apiUserFamily.deleteImage(formData);
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.userFamily.userFamilyImagePath = "";
          this.userFamily.userFamilyImageIsDefault = true;
          this.$emit("refresh");
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
};
</script>
